import React, { useEffect, useRef, useState } from "react";

import performRequest from "../../../api/request";
import { Toast } from "../../../CustomComponent/toast";
import { useLocation, useNavigate, useParams } from "react-router";
import { CustomErrorResponse } from "../../../CustomComponent/custom_error_response";
import { FcFeedback } from "react-icons/fc";
import SimpleButton from "../../../Components/layouts/simple_button";

const Sendbulktemplatemails = () => {
  const [templateData, setTemplateData] = useState({});
  const [isFetching, setIsFetching] = useState(false);
  const navigate = useNavigate();
  const { tempName } = useParams();
  const location = useLocation();

  useEffect(() => {
    performRequest("GET", `bulkemail/get-email-template/${tempName}`)
      .then((res) => {
        if (res.status === 200) {
          setTemplateData(res.data.Template);
        }
      })
      .catch((err) => {
        CustomErrorResponse(err);
      });
  }, []);

  const handleSendBulkMail = (event) => {
    event.preventDefault();
    let ans = window.confirm(
      `Are you sure you want to send bulk emails, this function sent more than 15,000 emails...`
    );

    if (ans) { 
      let requestData = { TemplateName: tempName };
      performRequest(
        "POST",
        `/bulkemail/send-bulk-template-email${location?.search}`,
        requestData
      )
        .then((res) => {
          if (res.status === 200) {
            Toast("success", res.data?.message);
          }
        })
        .catch((err) => {
          CustomErrorResponse(err);
        });
    }
  };
  const handleSendTestEmails = (event) => {
    event.preventDefault();
    let requestData = { TemplateName: tempName };
    performRequest("POST", `/bulkemail/send-test-template-email/`, requestData)
      .then((res) => {
        if (res.status === 200) {
          Toast("success", res.data?.message);
        }
      })
      .catch((err) => {
        CustomErrorResponse(err);
      });
  };


  return (
    <div className="page">
      <div className="page-wrapper">
        <div className="container-xl">
          <div className="page-body">
            <div className="card-header">
              <div className="col-md-8">
                <h2 className="page-title mb-1">
                  <FcFeedback className="fs-2  me-1" /> Email Marketing
                </h2>
                <h4 className="text-muted">Send and test emails</h4>
              </div>
            </div>
            <div className="row row-cards">
              <div className="col-lg-4 col-md">
                <form className="card">
                  <div className="card-header">
                    <h3 className="card-title">Choose options below</h3>
                  </div>
                  
                  <div className="card-footer">
                    <button
                      type="submit"
                      onClick={handleSendTestEmails}
                      className="btn btn-primary m-1"
                    >
                      Send Test Emails
                    </button>
                    <button
                      type="submit"
                      onClick={handleSendBulkMail}
                      className="btn btn-primary m-1"
                      disabled={isFetching}
                    >
                      Send Bulk Emails
                    </button>
                  
                  </div>
                </form>
              </div>
              <div className="col-lg-8 col-md">
                <div className="card">
                  <div className="card-body">
                    {templateData && (
                      <div>
                        <h1> Subject:- {templateData.SubjectPart}</h1>
                        <div
                          dangerouslySetInnerHTML={{
                            __html: templateData?.HtmlPart,
                          }}
                        />
                        <div className="footer text-end">
                          <SimpleButton
                            buttonText="Edit templete"
                            onClick={() =>
                              navigate(
                                `/edit-email-template/${tempName}${location?.search}`
                              )
                            }
                          />
                          <SimpleButton buttonText="Cancel" type="secondary" />
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Sendbulktemplatemails;
